import React, { useEffect } from 'react';
import { Combobox, Dialog, TextInputField, Pane, Label, Textarea, Switch, Text } from 'evergreen-ui';
import { db } from 'src/firebase';
import { doc, setDoc } from 'firebase/firestore';

const SubscriberModal = (props) => {
  const { isOpen, subscriber, categories, onClose, onSave } = props;
  const [creatingNewCategory, setCreatingNewCategory] = React.useState(false);
  const [category, setCategory] = React.useState(subscriber?.category || '');
  const [notes, setNotes] = React.useState(subscriber?.notes || '');

  useEffect(() => {
    if (subscriber) {
      setCategory(subscriber.category);
      setNotes(subscriber.notes);
    }
  }, [subscriber]);

  const updateSubscriber = async (email, category, notes) => {
    // Update subscriber
    const docRef = doc(db, 'subscribers', email);
    const newSubscriber = {
      email,
    };

    if (category) {
      newSubscriber.category = category;
    }

    if (notes) {
      newSubscriber.notes = notes;
    }

    setTimeout(() => {
      setCreatingNewCategory(false);
      setCategory('');
      setNotes('');
    }, 200);

    await setDoc(docRef, {
      ...newSubscriber,
    });

    onSave(newSubscriber);
  };

  return (
    <Dialog
      isShown={isOpen}
      title={'Edit Subscriber'}
      onCancel={onClose}
      onCloseComplete={onClose}
      onConfirm={() => {
        updateSubscriber(subscriber?.email, category, notes);
      }}
      confirmLabel="Save"
    >
      <TextInputField label="Email" value={subscriber?.email} disabled />
      <Pane marginBottom={24}>
        {creatingNewCategory && (
          <TextInputField label="Category" padding="unset" margin="unset" placeholder="New Category" value={category} onChange={(e) => setCategory(e.target.value)} />
        )}
        {!creatingNewCategory && (
          <>
            <Label marginBottom={8} display="block">
              Category
            </Label>
            <Combobox
              autocompleteProps={{
                position: 'bottom-left',
                popoverMinWidth: '496px',
              }}
              width="100%"
              openOnFocus
              items={categories}
              onChange={setCategory}
              value={category}
              selectedItem={category}
              placeholder="Category"
            />
          </>
        )}
        <Pane display="flex" gap="8px" marginTop="8px">
          <Switch checked={creatingNewCategory} onChange={(e) => setCreatingNewCategory(e.target.checked)} />
          <Text size={300}>Create New Category</Text>
        </Pane>
      </Pane>
      <Pane>
        <Label htmlFor="textarea-2" marginBottom={4} display="block">
          Notes
        </Label>
        <Textarea id="textarea-2" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notes..." />
      </Pane>
    </Dialog>
  );
};

export default SubscriberModal;
